export const SmsAdminFilterKey = {
  Action: 'action',
  Status: 'status',
  Tag: 'tag',
} as const;
export type SmsAdminFilterKey = (typeof SmsAdminFilterKey)[keyof typeof SmsAdminFilterKey];
export const SMS_ADMIN_FILTER_KEYS = [
  SmsAdminFilterKey.Action,
  SmsAdminFilterKey.Status,
  SmsAdminFilterKey.Tag,
] as const;
